import { Controller } from "@hotwired/stimulus"

// The Property field (custom and figure forms): free text, with every known property
// (and its logo) listed as you type. Picking one fills the field, which
// the form then saves like any other change; the logo beside the field
// follows whatever property it names.
export default class extends Controller {
  static targets = ["input", "results", "logo"]
  static values = { choices: Array }

  connect() {
    this.showLogo()
  }

  search() {
    this.showLogo()
    const query = this.inputTarget.value.trim().toLowerCase()
    const matches = this.choicesValue.filter((c) => !query || c.name.toLowerCase().includes(query))
    if (!matches.length || (matches.length === 1 && matches[0].name.toLowerCase() === query)) return this.close()
    this.resultsTarget.replaceChildren(...matches.slice(0, 12).map((choice) => this.row(choice)))
    this.resultsTarget.hidden = false
    this.active = -1
  }

  row(choice) {
    const button = document.createElement("button")
    button.type = "button"
    button.className = "cx-result cx-prop-row"
    button.setAttribute("role", "option")
    button.append(this.plate(choice))
    const name = document.createElement("b")
    name.textContent = choice.name
    button.append(name)
    button.addEventListener("mousedown", (event) => event.preventDefault())
    button.addEventListener("click", () => this.pick(choice.name))
    return button
  }

  // The property's logo, die-cut like a card's, or a coloured initial.
  plate(choice) {
    const plate = document.createElement("span")
    if (choice.logo) {
      plate.className = `fc-plogo cx-prop-logo${choice.light ? " is-light" : ""}${choice.mark ? " is-mark" : ""}`
      const img = document.createElement("img")
      img.src = choice.logo
      img.alt = ""
      plate.append(img)
    } else {
      plate.className = "fc-prop cx-prop-logo"
      const initial = document.createElement("i")
      initial.style.background = choice.color || "#374151"
      initial.textContent = choice.name[0]
      plate.append(initial)
    }
    return plate
  }

  pick(name) {
    this.inputTarget.value = name
    this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    this.inputTarget.dispatchEvent(new Event("change", { bubbles: true }))
    this.close()
    this.showLogo()
  }

  showLogo() {
    if (!this.hasLogoTarget) return
    const value = this.inputTarget.value.trim().toLowerCase()
    const choice = this.choicesValue.find((c) => c.name.toLowerCase() === value)
    this.logoTarget.replaceChildren(...(choice ? [this.plate(choice)] : []))
    this.logoTarget.hidden = !choice
  }

  key(event) {
    const rows = [...this.resultsTarget.querySelectorAll(".cx-result")]
    if (event.key === "Escape") return this.close()
    if (!rows.length || this.resultsTarget.hidden) return
    if (event.key === "ArrowDown" || event.key === "ArrowUp") {
      event.preventDefault()
      this.active = (this.active + (event.key === "ArrowDown" ? 1 : -1) + rows.length) % rows.length
      rows.forEach((row, i) => row.classList.toggle("on", i === this.active))
    } else if (event.key === "Enter" && this.active >= 0) {
      event.preventDefault()
      rows[this.active].click()
    }
  }

  close() {
    this.resultsTarget.hidden = true
    this.resultsTarget.replaceChildren()
  }
}
